"use client";

import { compose, cva, type VariantProps } from "cva";
import {
  BaseButton,
  type BaseButtonProps,
  baseButtonVariants,
} from "#ui-atoms/atoms/button/button";
import { cn } from "#ui-atoms/lib/utils";

const hcButtonVariants = compose(
  baseButtonVariants,
  cva({
    base: "uppercase",
    variants: {
      variant: {
        default: "bg-primary border-bg-primary",
        secondary: "bg-accent border-bg-accent text-white",
        outline:
          "bg-transparent border-primary text-primary hover:bg-primary/10 [&:is(:hover,[data-pressed])]:bg-primary/15",
        ghost:
          "h-fit bg-transparent border-transparent text-primary hover:bg-primary/10 data-pressed:bg-primary/10",
        destructive: "text-white disabled:text-white",
        "destructive-outline": "",
        link: "", // theres more than one link variant for hc and i think we should get rid of it and just use the actual ui link component
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }),
);

type HCVariantButtonVariant = VariantProps<typeof hcButtonVariants>["variant"];

export interface HCButtonProps
  extends Omit<BaseButtonProps, "variant">,
    VariantProps<typeof hcButtonVariants> {
  variant?: HCVariantButtonVariant;
}

export default function HCButton({
  className,
  variant,
  ...props
}: HCButtonProps) {
  return (
    <BaseButton
      {...props}
      className={cn(
        hcButtonVariants({
          variant,
          className,
        }),
      )}
      isNestedTenantComponent={true}
      variant={variant}
    />
  );
}
